import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { PageLayout } from "@/components/PageLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Heart, Coffee, Sparkles, ArrowRight, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import logoLight from "@/assets/logo-light_t.png";
import logoDark from "@/assets/logo-dark_t.png";

export default function General() {
  const navigate = useNavigate();

  // Auto-redirect to Health after a short delay, or users can choose
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/health");
    }, 5000);
    
    return () => clearTimeout(timer);
  }, [navigate]);

  const categories = [
    {
      title: "Health",
      description: "BMI, BMR, body fat, ideal weight, and macro split calculators",
      icon: Heart,
      href: "/health",
      color: "text-red-500"
    },
    {
      title: "Lifestyle",
      description: "Date, time, discount, fuel, and cooking measurement calculators",
      icon: Coffee,
      href: "/lifestyle",
      color: "text-orange-500"
    },
    {
      title: "Other",
      description: "Tips, currency, savings, and fitness activity calculators",
      icon: Sparkles,
      href: "/other",
      color: "text-purple-500"
    }
  ];

  return (
    <PageLayout>
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold tracking-tight">General Calculators</h1>
          <p className="text-xl text-muted-foreground">
            We've organized our calculators into focused categories
          </p>
        </div>

        <Card className="border-primary/20">
          <CardHeader>
            <CardTitle>Choose a Category</CardTitle>
            <CardDescription>
              Select the type of calculators you're looking for
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            {categories.map((category) => {
              const Icon = category.icon;
              return (
                <Button
                  key={category.href}
                  variant="outline"
                  className="w-full h-auto p-6 flex items-start gap-4 hover:border-primary/50"
                  onClick={() => navigate(category.href)}
                >
                  <Icon className={`h-8 w-8 ${category.color} flex-shrink-0`} />
                  <div className="flex-1 text-left">
                    <div className="font-semibold text-lg mb-1">{category.title}</div>
                    <div className="text-sm text-muted-foreground">{category.description}</div>
                  </div>
                  <ArrowRight className="h-5 w-5 flex-shrink-0" />
                </Button>
              );
            })}
          </CardContent>
        </Card>

        <p className="text-center text-sm text-muted-foreground">
          Redirecting to Health calculators in 5 seconds...
        </p>
      </div>
    </PageLayout>
  );
}
